import React, { useEffect, useState } from 'react'

const Tutorial = ({active}) => {
    const [primaryColor, setPrimaryColor] = useState(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())
    useEffect(() => {
      setPrimaryColor(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())
      
    }, [active])
    return (
        <svg width="22" height="22" viewBox="0 0 24 21" fill={primaryColor} xmlns="http://www.w3.org/2000/svg">
            <path d="M0 3.79167C0 1.69758 1.74608 0 3.9 0H20.1C22.2539 0 24 1.69758 24 3.79167V17.2083C24 19.3024 22.2539 21 20.1 21H3.9C1.74608 21 0 19.3024 0 17.2083V3.79167ZM3.9 1.75C2.7402 1.75 1.8 2.66408 1.8 3.79167V17.2083C1.8 18.3359 2.7402 19.25 3.9 19.25H20.1C21.2598 19.25 22.2 18.3359 22.2 17.2083V3.79167C22.2 2.66408 21.2598 1.75 20.1 1.75H3.9ZM8.4 7.29248V13.7084C8.4 14.5958 9.37855 15.1584 10.1783 14.7307L16.1778 11.5227C17.0068 11.0795 17.0068 9.92145 16.1778 9.47823L10.1783 6.27023C9.37855 5.8426 8.4 6.40512 8.4 7.29248Z" />
        </svg>

    )
}

export default Tutorial